import { useMemo } from 'react';
import { StyledInteractiveVideoActivity } from './InteractiveVideoActivity.styled';
import useInteractiveVideoActivity from './useInteractiveVideoActivity.hook';
import InteractiveVideoPlayer from '@/shared/Players/InteractiveVideoPlayer/InteractiveVideoPlayer';
import useActivityAnalytics from '@/shared/PlausibleAnalytics/useActivityAnalytics.hook';

export default function InteractiveVideoActivity({
  activity,
  taskProgressActions,
}) {
  const { actions: analyticsActions } = useActivityAnalytics({ activity });
  const { state, actions } = useInteractiveVideoActivity({
    activity,
    taskProgressActions,
    seoActions: analyticsActions,
  });

  const videoUrls = useMemo(() => {
    return activity?.data?.videoUrls?.filter(
      (videoUrl) =>
        (videoUrl.type?.includes('VideoHLS') &&
          process.env.NEXT_PUBLIC_HLS_ENABLED) ||
        !videoUrl.type?.includes('VideoHLS')
    );
  }, [activity?.data?.videoUrls]);

  return (
    <>
      <StyledInteractiveVideoActivity ratio={16 / 9}>
        <InteractiveVideoPlayer
          videoUrls={videoUrls}
          poster={activity?.data?.poster}
          questions={activity?.data?.questions}
          activityActions={actions.shared}
          activityName={activity?.activity?.name}
          noSeek={state.noSeek}
        />
      </StyledInteractiveVideoActivity>
    </>
  );
}
